import React from 'react';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';

function RedirectOnAuth() {
  const { authStatus } = useAuthenticator((ctx) => [ctx.authStatus]);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (authStatus === 'authenticated') {
      navigate('/dashboard', { replace: true });
    }
  }, [authStatus, navigate]);

  return null;
}

export default function SignUpPage() {
  return (
    <>
      <RedirectOnAuth />
      <Authenticator initialState="signUp" socialProviders={['google']} />
    </>
  );
}
